'use client';

import { AnimatePresence, motion } from 'motion/react';
import { JSX, useState } from 'react';

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Button, ShadCNButtonProps } from '@shadCN/ui/button';
import { DropdownMenuContent } from '@shadCN/ui/dropdown-menu';

// function DropdownItem({ children }: { children: React.ReactNode }) {
//   return (
//     <DropdownMenu.Item asChild>
//       <motion.button
//         className="item"
//         whileHover={highlight}
//         whileFocus={highlight}
//         whileTap={{ scale: 0.95 }}>
//         {children}
//       </motion.button>
//     </DropdownMenu.Item>
//   );
// }

interface Props {
  triggerButtonContent: JSX.Element;
  triggerButtonProps?: ShadCNButtonProps;
  dropdownContent?: JSX.Element[];
}

const MotionDropdown: React.FC<Props> = ({
  triggerButtonProps,
  triggerButtonContent,
  dropdownContent,
}) => {
  const [open, setOpen] = useState(false);
  const MotionComponent = motion.create(Button);

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger asChild>
        <MotionComponent
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          {...(triggerButtonProps ? triggerButtonProps : {})}>
          {triggerButtonContent}
        </MotionComponent>
      </DropdownMenu.Trigger>

      <AnimatePresence>
        {open && (
          <DropdownMenu.Portal forceMount>
            <DropdownMenuContent align="end" sideOffset={10} asChild>
              <motion.div
                className="content"
                initial={{ opacity: 0, scale: 0.85 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.85 }}
                transition={{ duration: 0.2 }}
                style={{ willChange: 'transform, opacity', minWidth: 160 }}>
                {dropdownContent}
              </motion.div>
            </DropdownMenuContent>
          </DropdownMenu.Portal>
        )}
      </AnimatePresence>
    </DropdownMenu.Root>
  );
};

/**
 * ==============   Styles   ================
 */
function StyleSheet() {
  return (
    <style>{`
            .container {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 200px;
            }

            .trigger {
                padding: 8px 16px;
                border-radius: 6px;
                background-color: var(--layer);
                color: #f5f5f5;
                border: 1px solid var(--border);
                cursor: pointer;
            }

            .content {
                min-width: 160px;
                background-color: var(--layer);
                border: 1px solid var(--border);
                border-radius: 6px;
                padding: 4px;
                transform-origin: var(--radix-dropdown-menu-content-transform-origin);
                box-sizing: border-box;
            }

        `}</style>
  );
}

export default MotionDropdown;
